export default __webpack_public_path__ + "static/media/50-tobylane.f1427f1d.mp3";